import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SystemPage } from '../system/system';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
producttype = '';
category_id = '';

  constructor(public navCtrl: NavController, public storage: Storage, public navParams: NavParams) {
  }  
  
   clicksystemtype(producttype, category_id) { 
    this.navCtrl.push(SystemPage, {
    producttype: producttype,
    category_id: category_id
    }); 
  } 

}
 


// WEBPACK FOOTER //
// ./src/pages/home/home.ts